
import component5           from '@/components/stat/StoreStockInventory.vue'
import component6           from '@/components/stat/ProductColorStockSupplier.vue'
import component7           from '@/components/stat/StockCheck.vue'
import component11          from '@/components/stat/StockBrandEanList.vue'



const menuId = 'rp4'
const routes = [


    {
        path        : '/stat4',
        name        : 'total_stock',
        component   : component5,
        meta        : { name : 'Valorizzazione Stock Sede', visible : true ,icon : 'fas fa-briefcase',menu:menuId,color:'#663333'},

    },
    {
        path        : '/stat5',
        name        : 'supplier_total_stock',
        component   : component6,
        meta        : { name : 'Valorizzazione Stock Fornitore', visible : true ,icon : 'fa fa-database',menu:menuId,color:'#666600'},

    },

    {
        path        : '/stat6',
        name        : 'supplier_stock_check',
        component   : component7,
        meta        : { name : 'Check List Stock Fornitore', visible : true ,icon : 'far fa-check-circle',menu:menuId,color:'#CC0066'},

    },
    
    {
        path        : '/stat14',
        name        : 'stock_brand_ean',
        component   : component11,
        meta        : { name : 'Stock Brand Ean List', visible : true ,icon : 'fas fa-list',menu:menuId,color:'#CC0066'},

    },
 
        
]
export default routes